/*
 * @Description: 会诊讲稿
 * @Author: likaifeng
 * @Date: 2023-11-29 18:45:13
 * @LastEditTime: 2025-09-26 16:05:18
 * @LastEditors: 李开锋
 */
import request from '@/common/request';

const apiPrefix = '';

/**
 * @description: 会诊讲稿列表
 * @author: likaifeng
 * @param {any} params
 * @return {*}
 * @Date: 2023-11-17 10:50:47
 */
export const httpLectureNotePage = (params: any) => {
  return request.post(`${apiPrefix}/lecture/note/page`, params);
};

/**
 * @description: 病例库 病例标签
 * @author: likaifeng
 * @param {*} params
 * @return {*}
 * @Date: 2023-11-29 15:23:22
 */
export function httpPatientShareLabel(params: any) {
  return request.post(`${apiPrefix}/labels/list`, params);
}

/**
 * @description: 分页查询讲稿
 * @author: likaifeng
 * @param {any} params
 * @return {*}
 * @Date: 2025-09-15 11:23:22
 */
export const httpPatientLectureNotePage = (params: any) => {
  return request.post(`${apiPrefix}/patient/lectureNote/page`, params);
};

/**
 * @description: 查询患者讲稿列表
 * @author: likaifeng
 * @param {any} params
 * @return {*}
 * @Date: 2025-09-26 11:23:22
 */
export const httpPatientLectureNoteList = (params: any) => {
  return request.post(`${apiPrefix}/patient/lectureNote/list`, params);
};

/**
 * @description: 生成患者讲稿
 * @author: likaifeng
 * @param {any} params
 * @return {*}
 * @Date: 2025-09-15 11:23:22
 */
export const httpPatientLectureNoteGenerate = (params: any) => {
  return request.post(`${apiPrefix}/patient/lectureNote/generate`, params);
};

/**
 * @description: 查询患者讲稿历史版本
 * @author: likaifeng
 * @param {any} params
 * @return {*}
 * @Date: 2025-09-15 11:23:22
 */
export const httpPatientLectureNoteHistory = (params: any) => {
  return request.post(`${apiPrefix}/patient/lectureNote/history`, params);
};

export default {};
